import { motion, HTMLMotionProps } from "framer-motion";
import { FC, ReactNode } from "react";
import { fadeInUp } from "utils/motionPresets";

export interface MotionSectionProps extends HTMLMotionProps<"div"> {
  children: ReactNode;
  className?: string;
  delay?: number;
  once?: boolean;
}

const MotionSection: FC<MotionSectionProps> = ({
  children,
  className = "",
  delay = 0,
  once = true,
  ...props
}) => {
  return (
    <motion.div
      className={className}
      initial="hidden"
      whileInView="visible"
      viewport={{ once, margin: "-80px" }}
      variants={{
        hidden: fadeInUp.hidden,
        visible: {
          ...fadeInUp.visible,
          transition: {
            ...(typeof fadeInUp.visible === "object" &&
            "transition" in fadeInUp.visible
              ? fadeInUp.visible.transition
              : {}),
            delay,
          },
        },
      }}
      {...props}
    >
      {children}
    </motion.div>
  );
};

export default MotionSection;
